import { observer, inject } from "mobx-react";
import {withRouter} from "react-router-dom";
import {NotificationSettings} from "@vidazoo/ui-framework";
export default inject((stores: any, props: any, context: any): any => ({
	userNotificationsSettingsStore: stores.userNotificationsSettingsStore,
	currentUserStore: stores.currentUserStore,
	profileStore: stores.profileStore,
}))(withRouter<any, any>(observer(NotificationSettings)));
